import SurveyResultsItem from './SurveyResultsItem';
import EmptyList from '@/components/Common/EmptyList';
import SurveyResultsSearchPanel from './SurveyResultsSearchPanel';
import ShButton from '../../Helpers/ShButton/index.vue'
import { hDeepCopy } from '@/utils/helpers';
import moment from 'moment';

// @vue/component
export default {
    name: 'SurveyResults',

    components: {
        SurveyResultsSearchPanel,
        SurveyResultsItem,
        ShButton,
        EmptyList
    },

    props: {
        projectsList: {
            type: Array,
            default: () => [],
        },
        projectUuid: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            currentPage: 1,
            surveysPerPage: 10,
            PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
            filterBy: {
                number: '',
                name: '',
                answered_date: [],
            },
            isSending: false,
            isCurrentCallVisible: false,
            isSurveyPopoverVisible: false,
        };
    },

    watch: {
        filterBy: {
            handler() {
                this.currentPage = 1;
            },
            deep: true,
        },
        surveysPerPage: {
            handler() {
                this.currentPage = 1;
            }
        },
    },

    computed: {
        surveyResultsList() {
            return this.$store.getters['campaign/surveyResultslist'];
        },
        surveyUuidsForFiltering() {
            const uniqueUuids = new Set();
            const unique = this.surveyResultsList.records.filter(element => {
                const isDuplicate = uniqueUuids.has(element._survey_uuid);
                uniqueUuids.add(element._survey_uuid);
                return !isDuplicate ? true : false;
            });
            return unique.map(item => ({ name: item._survey_name, uuid: item._survey_uuid }));
        },
        surveyResultsFilteredList() {
            let filteredResultsList = hDeepCopy(this.surveyResultsList.records)
            if (this.filterBy.number) {
                filteredResultsList = filteredResultsList.filter(item => item._num_a.includes(this.filterBy.number));
            }
            if (this.filterBy.name) {
                filteredResultsList = filteredResultsList.filter(item => item._survey_uuid === this.filterBy.name);
            }
            if (this.filterBy.answered_time && this.filterBy.answered_time.length > 0) {
                filteredResultsList = filteredResultsList.filter(item => moment(item._stamp).isBetween(this.filterBy.answered_time[0], this.filterBy.answered_time[1]));
            }
            return filteredResultsList;
        },
        surveyResultsToRenderPerPage() {
            return this.surveyResultsFilteredList.slice((this.currentPage - 1) * this.surveysPerPage, this.currentPage * this.surveysPerPage)
        },
        isEmpty() {
            return this.surveyResultsFilteredList.length === 0;
        },
        isSinglePage() {
            return this.surveyResultsFilteredList.length <= this.surveysPerPage;
        },
        isLoading() {
            return this.$store.getters['global/pendingAsyncStoreActions'].includes([
                'campaign/getSurveyResultsList',
            ]);
        }
    },
    async created() {
        await this.refreshRecordsList();
    },
    methods: {
        changeFilterBy(value) {
            this.filterBy = value
        },
        handleChangePage(page) {
            this.currentPage = page;
        },
        async refreshRecordsList() {
            await this.$store.dispatch('campaign/getSurveyResultsList');
        },

    },
};
